import React from 'react'

export default function SyllabusTipsCard() {
  const tips = [
    {
      title: 'Course & Subject Planning',
      description: 'Syllabus can be planned for each Course and Subject curriculum separately.',
      icon: 'menu_book',
    },
    {
      title: 'Target School / College',
      description:
        'Choose School/College name for syllabus targeted to specific institutions. Use "All" for universal curriculum across all branches.',
      icon: 'account_balance',
    },
    {
      title: 'Unique Chapter Sequence',
      description: 'Chapter / Lesson / Topic numbers must be distinct for each Course and Subject pairing.',
      icon: 'format_list_numbered',
    },
    {
      title: 'Schedule Timeline',
      description: 'Date From and Till Date define the planned period window for delivering this topic.',
      icon: 'date_range',
    },
    {
      title: 'Total Teaching Hours',
      description: 'Estimated total teaching hours required to complete theoretical and practical concepts.',
      icon: 'timelapse',
    },
    {
      title: 'Planned v/s Actual Tracking',
      description:
        'Syllabus tracking provides real-time visibility into planned versus actual completion hours and detects lecture schedule delays early.',
      icon: 'monitoring',
    },
  ]

  return (
    <div className="rounded-3xl border border-outline-variant/30 bg-surface-container-low/70 p-6 shadow-xs">
      <div className="flex items-center gap-2.5 text-primary">
        <span className="material-symbols-outlined text-2xl">lightbulb</span>
        <h3 className="font-display text-base font-black tracking-tight text-on-surface">
          Curriculum Guidelines &amp; Tips
        </h3>
      </div>
      <p className="mt-1 text-xs text-on-surface-variant leading-relaxed">
        Essential recommendations for configuring curriculum chapters, date milestones, and teaching timelines.
      </p>

      <div className="mt-6 flex flex-col gap-4">
        {tips.map((tip, idx) => (
          <div
            key={idx}
            className="flex items-start gap-3 rounded-2xl border border-outline-variant/20 bg-surface-container-lowest p-3.5 shadow-2xs transition hover:border-primary/30"
          >
            <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
              <span className="material-symbols-outlined text-base">{tip.icon}</span>
            </div>
            <div>
              <h4 className="text-xs font-bold text-on-surface">{tip.title}</h4>
              <p className="mt-0.5 text-[11px] text-on-surface-variant leading-relaxed">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
